import React from 'react'
import BaseImgBtn from './BaseImgBtn'

import img from 'assets/img/ic-trash-white.png'

const TrashWhiteBtn = (props: any) => {
  return <BaseImgBtn img={img} onClick={props.onClick} />
}

export default TrashWhiteBtn
